export default __webpack_public_path__ + "static/media/Crowcackle Gauntlets.f71fa385.jpg";